import { useEffect } from "react";
import { API_OPTIONS } from "../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { addTrailerVideo } from "../utils/movieSlice";
import axios from "axios";

//getting trailer video and updating redux

const useMovieTrailer = (movieId) => {
  const dispatch = useDispatch();

  const trailerVideo = useSelector((store) => store.movies.trailerVideo);

  const url = "https://api.themoviedb.org/3/movie/" + movieId + "/videos";

  async function getMovieVideos() {
    try {
      const response = await axios.get(url, API_OPTIONS);
      let responseOK = response && response.status === 200;

      if (responseOK) {
        const data = await response.data;
        const filterVideos = data.results.filter(
          (video) => video.type === "Trailer"
        );
    
        // If there is no trailer that is filterVideos will be empty then pick first video.
        const trailer = filterVideos.length ? filterVideos[0] : data.results[0];
        // adding it to redux store        
        dispatch(addTrailerVideo(trailer));
      }
    } catch (error) {
      console.error(error);
    }
  }







  // const getMovieVideos = async () => {
  //   const data = await fetch(
  //     "https://api.themoviedb.org/3/movie/" + movieId + "/videos",
  //     API_OPTIONS
  //   );
  //   const json = await data.json();
  //   const filterVideos = json.results.filter(
  //     (video) => video.type === "Trailer"
  //   );

  //   // If there is no trailer that is filterVideos will be empty then pick first video.
  //   const trailer = filterVideos.length ? filterVideos[0] : json.results[0];
  //   // adding it to redux store
  //   console.log("FETCh", trailer)
    
  //   dispatch(addTrailerVideo(trailer));
  // };
  useEffect(() => {
    !trailerVideo && getMovieVideos();
  }, []);
};

export default useMovieTrailer;
